export default __webpack_public_path__ + "static/media/profileSidebarIcon_statistics.9117591a.svg";